import React, { useState, useEffect } from 'react'
import StaffImg from '../assets/staff-img.png';
import StaffImg1 from '../assets/staff-img1.gif';
import Loading from '../general/Loading';


const ExcDeliveryHistory = ({ userData }) => {
    const [orders, setOrders] = useState([]);
    const [excOrders, setexcOrders] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [selectedOrder, setSelectedOrder] = useState('');
    const [showDetail, setShowDetail] = useState(false);
       const [loading, setLoading] = useState(false);
       const [orderAddress, setOrderAddress] = useState('');    

    // Fetch staff members on component mount
    useEffect(() => {
        const fetchAssignedOrder = async () => {
            setLoading(true);
            try {
                const response = await fetch('https://api.kcmstore.in/store/get-exchange-assigned-order');
                if (response.ok) {
                    const data = await response.json();
                    setLoading(false);
                    setOrders(data);
                } else {
                    setLoading(false);
                    console.error('Failed to fetch staff members');
                }
            } catch (error) {
                setLoading(false);
                console.error('Error fetching staff:', error);
            }
        };

        fetchAssignedOrder();
    }, []);

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
    };

      const filteredOrders = orders.filter(order =>
        formatDate(order.order_date).toLowerCase().includes(searchQuery.toLowerCase()) ||
        order.delivery_agent_name.toLowerCase().includes(searchQuery.toLowerCase()) ||
        order.order_status.toLowerCase().includes(searchQuery.toLowerCase())
      );

    const handleShowDetail = (order) => {
        setSelectedOrder(order);
        console.log(order);
        setShowDetail(true);
    }

    const getOrderLocation = async (lat, lon) => {
      try {
          const response = await fetch(`https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lon}&format=json`);
          const data = await response.json();
  
          return data.display_name || 'Unknown location';
      } catch (error) {
          console.error('Error fetching order address:', error);
          return 'Failed to fetch location';
      }
  };
  
    useEffect(() => {
      const fetchOrderAddress = async () => {
          if (selectedOrder?.lat && selectedOrder?.longi) {
              const address = await getOrderLocation(selectedOrder.lat, selectedOrder.longi);
              setOrderAddress(address);
          } else {
              setOrderAddress(`${selectedOrder.customer_location || selectedOrder.customer_address}, ${selectedOrder.customer_city}, ${selectedOrder.customer_state}, ${selectedOrder.customer_pincode}`);
          }
      };
  
      fetchOrderAddress();
  }, [selectedOrder]);
  


    return (
        <>
            <section className='py-4 bg-light'>
                <div className='px-3'>

                    <div className='d-flex'>
                        <p className='sec-heading'>Exchange Orders</p>
                        <span className='sec-text animate__animated animate__flash animate__slow animate__infinite'>History</span>
                    </div>

                    <div className='d-flex bg-white rounded-4'>
                        <i class="fa-solid fa-magnifying-glass text-darkblue py-3 px-3"></i>
                        <input
                            type="text"
                            className="form-input rounded-4 border-0"
                            placeholder="Search Order"
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                        />
                    </div>

                    <div className="table-responsive bg-white rounded-4 mt-4">
                        <table className='w-100'>
                            <tr style={{ borderBottom: '2px solid var(--darkblue)' }}>
                                <th className='px-3 py-3'>Request On</th>
                                <th className='px-3 py-3'>Agent Delivered</th>
                                <th className='px-3 py-3'>Agent Contact</th>
                                <th className='px-3 py-3'>Req Status</th>
                                <th className='px-3 py-3'>Details</th>
                            </tr>


                            {filteredOrders.length > 0 ? (
                                filteredOrders.map((order, index) => (
                                    <tr className='text-muted fw-semibold' style={{ backgroundColor: index % 2 === 0 ? 'var(--peach)' : 'white' }}>
                                        <td className='px-3 py-2'>{formatDate(order.req_on) || 'NA'}</td>
                                        <td className='px-3 py-2'>{order.delivery_agent_name || 'NA'}</td>
                                        <td className='px-3 py-2'>{order.delivery_agent_phone || 'NA'}</td>
                                        <td className='px-3 py-2 text-success'>{order.req_status || 'NA'}</td>
                                        <td className='px-3 py-2 cursor-pointer' onClick={() => handleShowDetail(order)}><span className='danger-btn'>View</span></td>
                                    </tr>
                                ))
                            )

                                : (
                                    <>
                                        <tr className='text-center'>
                                            <td colSpan='5'>
                                                <img src={StaffImg1} className='img-fluid col-lg-4 col-md-6 col-sm-6 col-10 my-3' alt='Staff' />
                                                <p className='fw-bold'>No Orders Delivered yet.</p>
                                            </td>
                                        </tr>
                                    </>
                                )}
                        </table>
                    </div>

                </div>
            </section>


            {showDetail && selectedOrder && orderAddress && (
        <>
          <section className='invoice-dialog px-2'>
            <div className='invoice-dialog-inner animate__animated animate__zoomIn col-lg-8 mx-auto px-lg-5 py-lg-5 px-3 py-3 text-start'>

              <p className='sec-heading fs-4'>Exchange Detail</p>

              <div className='invoice-area my-4'>
                <div className='d-flex justify-content-between'>
                  <p className='para-text'><span className='fw-semibold'>Customer Details:</span><br />Name: {selectedOrder.customer_name}
                  <br />Mobile No: {selectedOrder.customer_mobile}<br />
                  Delivery Address: {orderAddress}</p>
                  <p className='para-text'><span className='fw-semibold'>Request Details:</span><br />Request id:
                  {selectedOrder.id}<br />Req On: {formatDate(selectedOrder.req_on)}<br />Status: {selectedOrder.req_status}<br />
                  Remark (if Any): {selectedOrder.remark || 'NA'}</p>
                </div>
                {/* flex ends */}
                <hr />

{/* ... inside your JSX where you display items and grand total ... */}

<div className='table-responsive'>
  <table className='w-100'>
    <tr>
      <th className='px-2 py-2'>Product</th>
      <th className='px-2 py-2'>Price</th>
      <th className='px-2 py-2'>Qty</th>
      <th className='px-2 py-2'>Total ₹</th>
    </tr>

    {typeof selectedOrder.ex_items === 'string' ? (
      (() => {
        try {
          const parsedItems = JSON.parse(selectedOrder.ex_items);
          if (Array.isArray(parsedItems)) {
            // Calculate grand total here
            const grandTotal = parsedItems.reduce((acc, item) => acc + Number(item.total_price), 0);

            return (
              <>
                {parsedItems.map((item, index) => (
                  <tr key={index}>
                    <td className='px-2 py-2'>{item.name}</td>
                    <td className='px-2 py-2'>₹{item.price}</td>
                    <td className='px-2 py-2'>{item.qty}</td>
                    <td className='px-2 py-2'>₹{item.total_price}</td>
                  </tr>
                ))}
                {/* Show grand total row */}
                <tr>
                  <td colSpan="4" className='px-2 pt-2 fw-semibold'>Grand Total: ₹{grandTotal.toFixed(2)}</td>
                </tr>
              </>
            );
          }
        } catch (error) {
          return <p>Failed to get items.</p>
        }
      })()
    ) : (
      <p>No items available.</p>
    )}

  </table>
</div>

                {/* table area */}

                <hr />

                {/* <p className='para-text'>Grand Total {grandTotal}</p> */}
                <p className='para-text'><span className='text-success fw-semibold'>OTP for Verfication: {selectedOrder.otp}</span><br />This Order has been {selectedOrder.order_status} by {selectedOrder.delivery_agent_name}.<br/>You can contact Delivery Agent on {selectedOrder.delivery_agent_phone}</p>

              </div>
              {/* invoice ends */}
              <button className='danger-btn' onClick={() => setShowDetail(false)}>Close</button>


            </div>
          </section>
        </>
      )}

{loading && <Loading setLoading={setLoading} />}


        </>
    )
}

export default ExcDeliveryHistory
